/**
 * Simple one-liner typeguard for validing and casting a string as a key into an object.
 * @param {object} x The object to evaluate against.
 * @param {string} k The key to check for
 * @returns {k is keyof T} True if the provided value is a valid key into {@link x}.
 */
export const isKey = <T extends object>(x: T, k: PropertyKey): k is keyof T => k in x;

export const extractFunctions = <T extends object>(source: T): Array<keyof T> => {
  return Array.from(Object.entries(source)).reduce((arr, [key, check]) => {
    if (typeof check === 'function') {
      arr.push(key as keyof T);
    }
    return arr;
  }, [] as Array<keyof T>);
};
